import React, { useEffect, useCallback } from 'react';
import styles from './index.module.sass';
import LoginFrame from 'layout/login-frame';
import TextInput from 'componets/text-input';
import Button from 'componets/button';
import {
  CHANGE_SUB_ACCOUNT,
  CHANGE_PASSWORD,
  CHANGE_USERNAME,
  EXPAND_SUB_ACCOUNT_INPUT,
  useLoginContext,
} from './use-login';
import { PASSWORD_CHAR_REGEX } from 'helpers/rule-validation';
import arrowDown from 'images/arrow_down.svg';
import { SliderButton } from '@typeform/embed-react';
import analytics from 'service/analytics';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const LoginForm = () => {
  const { state, dispatch, onLogin, onLockTab, onUnlockTab } = useLoginContext();
  const { search } = useLocation();
  const { username } = qs.parse(search);

  useEffect(() => {
    analytics.track('登入頁_pageview');

    // 如果有 username 則自動填入
    if (username) {
      changeUsername(username);
    }
  }, []); //eslint-disable-line

  const changeUsername = useCallback(
    value => {
      dispatch({
        type: CHANGE_USERNAME,
        payload: value,
      });
    },
    [dispatch]
  );

  const changePassword = useCallback(
    value => {
      dispatch({
        type: CHANGE_PASSWORD,
        payload: value,
      });
    },
    [dispatch]
  );

  const changeSubAccount = useCallback(
    value => {
      dispatch({
        type: CHANGE_SUB_ACCOUNT,
        payload: value,
      });
    },
    [dispatch]
  );

  const onLoginClick = () => {
    analytics.track('登入頁_登入_click');
    onLogin();
  };

  const expandSubAccountInput = useCallback(() => {
    analytics.track('登入頁_展開子帳號_click');
    dispatch({ type: EXPAND_SUB_ACCOUNT_INPUT });
  }, [dispatch]);

  const SubAccount = () => {
    if (!state.isExpandSubAccountInput)
      return (
        <div className={styles['expand-sub-account']} onClick={expandSubAccountInput}>
          請輸入子帳號
          <img src={arrowDown} alt="arrow-down" />
        </div>
      );

    return (
      <TextInput
        placeholder="輸入子帳號（非必填）"
        value={state.subAccount}
        errorMessage={state.subAccountErrorMessage}
        onTextChange={changeSubAccount}
        onFocus={() => {
          analytics.track('登入頁_子帳號_click');
          onUnlockTab();
        }}
      />
    );
  };

  return (
    <>
      <LoginFrame>
        <div className={styles.title}>登入企業費用管理後台</div>
        <div className={styles.form}>
          <div className={styles['form-input']}>
            <TextInput
              label="企業帳號"
              placeholder="輸入企業帳號"
              errorMessage={state.usernameErrorMessage}
              value={state.username}
              onTextChange={changeUsername}
              onFocus={() => {
                onUnlockTab();
                analytics.track('登入頁_企業帳號_click');
              }}
            />
          </div>
          <div className={`${styles['form-input']} ${styles.sub}`}>{SubAccount()}</div>
          <div className={styles['form-input']}>
            <TextInput
              label="企業密碼"
              placeholder="輸入密碼"
              type="password"
              value={state.password}
              digits={PASSWORD_CHAR_REGEX}
              errorMessage={state.passwordErrorMessage}
              onTextChange={changePassword}
              onKeyPressEnter={onLoginClick}
              onFocus={() => {
                analytics.track('登入頁_企業密碼_click');
                onLockTab();
              }}
            />
          </div>
        </div>
        <Button
          type="submit"
          theme="black"
          style={{ marginTop: '30px' }}
          className={styles['login-button']}
          onClick={onLoginClick}
          loading={state.loading}
        >
          登入
        </Button>
      </LoginFrame>
      <div className={styles.other}>
        <span>還沒有帳號？</span>
        <SliderButton
          tracking={{ utm_source: 'web', utm_medium: 'autopass-for-business', utm_term: 'register_button' }}
          position="right"
          id="TkBBrKDk"
          className={styles['typeform-button']}
        >
          <Button
            variant="outline"
            size="large"
            className={styles['button-register']}
            onClick={() => analytics.track('登入頁_免費註冊試用_click')}
          >
            免費註冊試用
          </Button>
        </SliderButton>
      </div>
    </>
  );
};

export default LoginForm;
